<template>
	<svg viewBox="0 0 32 32">
		<path d="M9.343 17.345c2.209-0.002 4-1.793 4-4.003 0-2.211-1.792-4.003-4.003-4.003s-4.003 1.792-4.003 4.003c0 0.001 0 0.001 0 0.002v-0c0 0.001 0 0.002 0 0.003 0 2.208 1.79 3.998 3.998 3.998 0.003 0 0.006 0 0.009 0h-0zM25.361 9.336h-10.685v9.339h-10.673v-12.004h-2.669v20.014h2.669v-3.996h24.015v4.003h2.669v-12.012c0-0.001 0-0.003 0-0.005 0-2.946-2.389-5.335-5.335-5.335-0.001 0-0.002 0-0.003 0h0z" />
	</svg>
</template>
